import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AvailableFeatures } from 'bookraw/shared/models/feature.model';
import { environment } from 'env/environment';

export function isFeatureDisabled(feature: AvailableFeatures): boolean {
  return environment.disabledFeatures.includes(feature)
}

@Directive({ selector: '[requireFeature]' })
export class RequireFeatureDirective implements OnInit {
  @Input() requireFeature: AvailableFeatures;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    if ( isFeatureDisabled(this.requireFeature) ) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
